export default __webpack_public_path__ + "static/media/next-small-green.88279674.svg";